import { useTranslations } from 'next-intl'

import BlockContent from '~/components/atoms/BlockContent/BlockContent'
import Button, {
  ButtonTypes,
  ButtonVariants,
} from '~/components/atoms/Button/Button'
import Container from '~/components/atoms/Container/Container'
import Fixture from '~/components/atoms/Fixture/Fixture'
import type { ImageProps } from '~/components/atoms/Image/Image'
import Image from '~/components/atoms/Image/Image'
import Link from '~/components/atoms/Link/Link'
import Text, { TextSizes } from '~/components/atoms/Text/Text'
import { ComponentTheme } from '~/components/themes'

import styles from './SubCategoryListing.module.css'

type SubCategoryItem = {
  name: string
  slug: string
  summary: any
  leadImage?: ImageProps | any
}

export interface SubCategoryListingProps {
  testID?: string

  categories?: SubCategoryItem[]
}

export default function SubCategoryListing({
  testID,
  categories,
}: SubCategoryListingProps) {
  const t = useTranslations('common')
  return (
    <div className={styles.base}>
      <Fixture theme={ComponentTheme.secondary}>
        <div className={styles.mainContainer}>
          <Container>
            <div className={styles.categoryContainer}>
              {categories?.map((category: SubCategoryItem) => (
                <Link
                  className={styles.categoryItem}
                  key={`category-list-sub-item-${category.slug}`}
                  href={`/articles/${category.slug}`}
                >
                  {category?.leadImage?.asset && (
                    <Image
                      asset={category?.leadImage?.asset}
                      alt={`${category.name} - MyArtBroker`}
                    />
                  )}

                  <Text
                    className={styles.title}
                    size={TextSizes.primaryTitleMed}
                  >
                    {category.name}
                  </Text>
                  {category.summary && (
                    <div className={styles.summary}>
                      <BlockContent value={category.summary}></BlockContent>
                    </div>
                  )}
                  <Button
                    variant={ButtonVariants.capsUnderlineSml}
                    button={{
                      type: ButtonTypes.button,
                    }}
                    link={`/articles/${category.slug}`}
                    className={styles.ctaLink}
                  >
                    <div
                      dangerouslySetInnerHTML={{
                        __html: t('exploreArticles'),
                      }}
                    />
                  </Button>
                </Link>
              ))}
            </div>
          </Container>
        </div>
      </Fixture>
    </div>
  )
}
